import { taxCalculationMethods } from '@/constants/flagAndCategory';
import { taxStatusOptions } from '@/constants/status';

const headers = [
  { title: 'Kode', key: 'code', sortable: true },
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'Rate', key: 'rate', align: 'end', sortable: true },
  { title: 'Metode Kalkulasi', key: 'calc_method', align: 'center', sortable: true },
  { title: 'Kode Jenis Pajak', key: 'tax_type_code', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  {
    title: 'Jenis Pajak',
    key: 'tax_type_id',
    type: 'select',
    selectOptions: [], // Values will be supplied inside TaxList.vue based on values returned from backend
  },
  { title: 'Kode', key: 'code', type: 'text' },
  { title: 'Nama', key: 'name', type: 'text' },
  {
    title: 'Metode Kalkulasi',
    key: 'calc_method',
    type: 'select',
    selectOptions: taxCalculationMethods.map(({ value, title }) => ({ value, title })),
  },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: taxStatusOptions.map(({ value, title }) => ({ value, title })),
  },
];

export { filters, headers };
